export const TEST_CLIENT_KEY =
  "pk_test_51NhIfPK9i1MS2msNgIrkFMW8qfjv3UEHyoGLDV5beWGaw71lY6GEbB3uq3PHK5WAoisse5sAaO2Ub3OG1RC750cE00oWiV3T57";
